import { useEffect, useLayoutEffect, useState } from 'react'
import CampaignCountdownMessagePc from '../../public/campaign_countdown_message_pc.png'
import CampaignCountdownMessageSp from '../../public/campaign_countdown_message_sp.png'
import {
  RemainingTime,
  remainingTimeForCountdown,
} from '../../utils/campaignCountdown'

const TrialHeaderCountdown = () => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)
  const [remainingTime, setRemainingTime] = useState<RemainingTime>({
    milliSeconds: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  const isMobile = windowWidth <= 450

  const scrollToAwardContent = () => {
    const anchor = document.getElementById('award-content')
    anchor?.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    setWindowWidth(window.innerWidth)
  }, [window.innerWidth])

  useLayoutEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime(remainingTimeForCountdown())
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  return (
    <div
      className="w-full h-[44px] flex justify-center items-center fixed z-[1] top-0 bg-pink-light gap-[1vw] py-2"
      id="trial-header-countdown"
    >
      <img
        className="w-[425px] h-auto sp:w-[35vw]"
        src={
          isMobile
            ? CampaignCountdownMessageSp.src
            : CampaignCountdownMessagePc.src
        }
        alt="カウントダウンメッセージ"
      />
      <div className="flex items-center h-full gap-[0.3vw] sp:gap-[0.7vw]">
        <p className="bg-white text-primary w-[33px] text-center text-[22px] font-bold rounded-[2px] sp:text-[4.2vw] sp:w-[8.7vw]">
          <span>{remainingTime.days.toString().padStart(2, '0')[0]}</span>
          <span>{remainingTime.days.toString().padStart(2, '0')[1]}</span>
        </p>
        <p className="text-primary text-[14px] font-bold sp:text-[10px]">
          <span>日</span>
        </p>
        <p className="bg-white text-primary w-[33px] text-center text-[22px] font-bold rounded-[2px] sp:text-[4.2vw] sp:w-[8.7vw]">
          <span>{remainingTime.hours.toString().padStart(2, '0')[0]}</span>
          <span>{remainingTime.hours.toString().padStart(2, '0')[1]}</span>
        </p>
        <p className="text-primary text-[14px] font-bold sp:text-[10px]">
          <span>時間</span>
        </p>
        <p className="bg-white text-primary w-[33px] text-center text-[22px] font-bold rounded-[2px] sp:text-[4.2vw] sp:w-[8.7vw]">
          <span>{remainingTime.minutes.toString().padStart(2, '0')[0]}</span>
          <span>{remainingTime.minutes.toString().padStart(2, '0')[1]}</span>
        </p>
        <p className="text-primary text-[14px] font-bold sp:text-[10px]">
          <span>分</span>
        </p>
        <p className="bg-white text-primary w-[33px] text-center text-[22px] font-bold rounded-[2px] sp:text-[4.2vw] sp:w-[8.7vw]">
          <span>{remainingTime.seconds.toString().padStart(2, '0')[0]}</span>
          <span>{remainingTime.seconds.toString().padStart(2, '0')[1]}</span>
        </p>
        <p className="text-primary text-[14px] font-bold sp:text-[10px]">
          <span>秒</span>
        </p>
      </div>
    </div>
  )
}

export default TrialHeaderCountdown
